import { CalendarRowStyles } from './CalendarRow.types'

const makeStyles = (): CalendarRowStyles => ({
	row: {
		display: 'flex'
	}
})

export default makeStyles